import $ from "jquery";

import { useContext } from "react";

import { MainContext } from "./../../context/main-context";

import { FaAngleUp } from "react-icons/fa";
import MainPanelCarousel from "./MainPanelCarousel";
import { useEffect } from "react";

const MainPanel = () => {
  useEffect(() => {
    if (
      !$.isEmptyObject(mainContext.mainContent) &&
      mainContext.mainContent.id == 303
    )
      mainContext.toggleBusLineDataShow(true);
    else mainContext.toggleBusLineDataShow(false);
  });
  const mainContext = useContext(MainContext);
  const Main_data = mainContext.mainContent;

  const title = $.isEmptyObject(mainContext.mainContent)
    ? "عنوان پنل اصلی"
    : mainContext.mainContent.title;

  const handleShowPanel = (state) => {
    mainContext.toggleShowMainPanel(state);
    mainContext.toggleShowLeftPanel(false);
  };
  return (
    <>
      <div
        className={
          mainContext.showMainPanel
            ? "main-panel main-panel-show f-16px f-Black"
            : "main-panel f-16px f-Black"
        }
      >
        <div className="main-panel-container">
          <div className="main-panel-title">
            <h2 className="f-Bold">{title}</h2>
          </div>
          <div className="main-panel-content">
            <div className="mp-carousel">
              {/* <div className="mp-card">کارت پنل اصلی2</div> */}
              <MainPanelCarousel data={Main_data} />
            </div>
          </div>
        </div>

        <div
          className="main-panel-close-btn"
          onClick={() => handleShowPanel(false)}
        >
          <FaAngleUp />
        </div>
      </div>
    </>
  );
};

export default MainPanel;
